import { Skeleton, useMediaQuery, useTheme } from '@mui/material';
import { isUndefined } from 'lodash-es';
import type { FC } from 'react';
import type { SkeletonListProps } from './SkeletonList.types';

const SkeletonList: FC<SkeletonListProps> = ({ count, width = '100%', height, sx }) => {
  const themeHook = useTheme();
  const isMobileLayout = useMediaQuery(themeHook.breakpoints.down('sm'));

  return (
    <>
      {[...Array(count).keys()].map((_, i) => (
        <Skeleton
          animation="wave"
          width={width}
          height={!isUndefined(height) ? height : isMobileLayout ? 46.5 : 48.5}
          sx={sx}
          key={i}
        />
      ))}
    </>
  );
};

export default SkeletonList;
